(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["affirm-as-low-as"] && !Shopify.designMode) return;
  try {
    (function () {
    function rewriteAffirm(container) {
      var link = container.querySelector('a.affirm-modal-trigger');
      if (!link) return;

      link.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && /or as low as/i.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/or as low as/i, 'As low as');
        }
      });

      // Unwrap the link so there is no modal trigger
      link.replaceWith.apply(link, Array.from(link.childNodes));
    }

    function observe(el) {
      if (el.dataset.affirmObserved) return;
      el.dataset.affirmObserved = 'true';
      rewriteAffirm(el);
      new MutationObserver(function () {
        rewriteAffirm(el);
      }).observe(el, { childList: true, subtree: true });
    }

    function refreshAffirm() {
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function') {
        window.affirm.ui.ready(function () {
          window.affirm.ui.refresh();
        });
      }
    }

    // Variant change. Promo prices can be set per variant (custom.promo_price on the variant overrides
    // the product's), and the variant JSON doesn't include metafields, so prefer the amount and promo
    // state rendered for the new variant in the re-rendered section. Without that, fall back to the
    // new variant's price unless the block is showing a promo price.
    function onVariantUpdate(event) {
      var detail = event.detail || {};
      var variant = detail.resource;
      var productId = detail.data && detail.data.productId;
      var html = detail.data && detail.data.html;
      if (!variant || variant.price == null) return;

      var changed = false;
      document.querySelectorAll('.affirm-as-low-as-block').forEach(function (block) {
        if (productId && block.dataset.productId !== String(productId)) return;

        var current = block.querySelector('.affirm-as-low-as');
        var renderedBlock =
          html && typeof html.querySelector === 'function'
            ? html.querySelector('.affirm-as-low-as-block[data-product-id="' + block.dataset.productId + '"]')
            : null;
        var renderedAmount = renderedBlock && renderedBlock.querySelector('.affirm-as-low-as');
        var amount;

        if (renderedAmount) {
          amount = renderedAmount.getAttribute('data-amount');
          block.dataset.promo = renderedBlock.dataset.promo;
        } else {
          if (block.dataset.promo === 'true') return;
          amount = String(variant.price);
        }

        if (current && amount && current.getAttribute('data-amount') !== amount) {
          current.setAttribute('data-amount', amount);
          changed = true;
        }
      });

      if (changed) refreshAffirm();
    }

    function init() {
      var containers = document.querySelectorAll('.affirm-as-low-as-block .affirm-as-low-as');
      if (!containers.length) return;
      containers.forEach(observe);

      // Ask Affirm to render any placeholders added after its initial scan
      refreshAffirm();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor: re-init when a section is added or re-rendered
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('variant:update', onVariantUpdate);
  })();
  } catch(e) { console.error(e); }
})();

})();
